import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Button from './Button';

const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  actionLabel,
}) => {
  const { theme } = useTheme();

  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '64px 24px',
    textAlign: 'center',
  };

  const iconWrapperStyles = {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: theme.colors.backgroundSecondary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  };

  const titleStyles = {
    fontSize: '20px',
    fontWeight: '600',
    color: theme.colors.text,
    marginBottom: '8px',
  };

  const descriptionStyles = {
    fontSize: '14px',
    color: theme.colors.textSecondary,
    marginBottom: '24px',
    maxWidth: '400px',
    lineHeight: '1.6',
  };

  return (
    <div style={containerStyles}>
      {Icon && (
        <div style={iconWrapperStyles}>
          <Icon size={36} color={theme.colors.textSecondary} />
        </div>
      )}
      <h3 style={titleStyles}>{title}</h3>
      {description && <p style={descriptionStyles}>{description}</p>}
      {action && actionLabel && (
        <Button onClick={action} variant="primary">
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
